import { render, staticRenderFns } from "./pageManage.vue?vue&type=template&id=285a55e4&scoped=true"
import script from "./pageManage.vue?vue&type=script&lang=js"
export * from "./pageManage.vue?vue&type=script&lang=js"
import style0 from "./pageManage.vue?vue&type=style&index=0&id=285a55e4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285a55e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('285a55e4')) {
      api.createRecord('285a55e4', component.options)
    } else {
      api.reload('285a55e4', component.options)
    }
    module.hot.accept("./pageManage.vue?vue&type=template&id=285a55e4&scoped=true", function () {
      api.rerender('285a55e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/matrix/pageManage.vue"
export default component.exports